import React from 'react'
import { DateRangePickerContext } from './date-range-picker-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type DateRangePickerPrevProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const DateRangePickerPrev = React.forwardRef<HTMLDivElement, DateRangePickerPrevProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(DateRangePickerContext)
    if (!context) {
      throw new Error('Cannot find date picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToPreviousMonth)
      })
    }
  }
) as WithForwardRefType

DateRangePickerPrev.displayName = 'DateRangePickerPrev'

interface WithForwardRefType extends React.FC<DateRangePickerPrevProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(
    props: DateRangePickerPrevProps<T>
  ): ReturnType<React.FC<DateRangePickerPrevProps<T>>>
}
